/* eslint-disable react/jsx-props-no-spreading */
import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { useCoreAuth } from '@carvana/core-auth';
import SignIn from '../SignIn';

const ProtectedRoute = ({
  path,
  component,
}: {
  path: string;
  component: FC;
}) => {
  const { getUserState } = useCoreAuth();
  const { isLoggedIn } = getUserState();

  return <Route path={path} component={isLoggedIn ? component : SignIn} />;
};

export default ProtectedRoute;
